import React from "react";
import SvgIcn from "../../data/IconCompo"; // Assuming you have an icon component

const CheckZ = ({ label, checked, onChange, icon, value, className }) => {
  const handleClick = () => {
    onChange(value, !checked);
  };

  return (
    <div className={`checkbox-hero ${className}`} onClick={handleClick}>
      <div className={`checkbox-btn ${checked ? "checked" : "unchecked"}`}>
        {checked ? <SvgIcn name="ok" /> : <SvgIcn name="ok" />}
      </div>

      <span className={`checkbox-text ${checked ? "checked" : ""}`}>
        {label}
      </span>
      {icon && <SvgIcn name={icon} />}
    </div>
  );
};

export default CheckZ;
